import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import moment from 'moment';

import { ConnectionDropdown } from 'SF/ConnectionDropdown';
import { CohortDropdown } from 'SF/CohortDropdown';
import DateRange from 'SF/date/DateRange';

import { studentFiltersAppliedEvent } from 'utils/events';

import { NotificationCenter } from 'utils/types';

export default class IntakeMainFilterPanel extends React.Component {
  constructor(props) {
    super(props);

    const prevState = JSON.parse(localStorage.getItem('intakeFilterPanel')) || {};
    this.state = {
      connection: prevState.connection || -1,
      cohorts: prevState.cohorts || [],
      startUpdateDate: moment().subtract(30, 'days'), // default start date should be 30 days ago
      endUpdateDate: moment() // default end date should be today
    };
  }

  handleConnectionChange = (connection) => {
    this.setState({ connection });
  }

  handleCohortChange = (cohorts) => {
    this.setState({ cohorts });
  }

  handleDatesChange = ({startDate, endDate}) => {
    this.setState({
      startUpdateDate: startDate,
      endUpdateDate: endDate
    });
  }

  handleLoadFilterIntakeStore = () => {
    localStorage.setItem('intakeFilterPanel', JSON.stringify({
      connection: this.state.connection,
      cohorts: this.state.cohorts
    }));
    this.props.notificationCenter.fireEvent(studentFiltersAppliedEvent, {
      connection: this.state.connection,
      cohorts: this.state.cohorts,
      startUpdateDate: this.state.startUpdateDate.format('YYYY-MM-DD'),
      endUpdateDate: this.state.endUpdateDate.format('YYYY-MM-DD')
    });
  }

  componentDidUpdate() {
    this.handleLoadFilterIntakeStore();
  }

  componentDidMount() {
    this.handleLoadFilterIntakeStore();
  }

  render() {
    return (
      <Form>
        <div className="equal width fields">
          <div className="field">
            <label tabIndex="0" htmlFor="intakeConnectionDropdown">Active Connections</label>
            <ConnectionDropdown id="intakeConnectionDropdown" defaultConnection={this.state.connection} onChange={this.handleConnectionChange} />
          </div>
          { this.props.cohortsEnabled &&
              <div className="field">
                <label tabIndex="0" htmlFor="intakeCohortDropdown">Cohort</label>
                <CohortDropdown id="intakeCohortDropdown" defaultCohortIds={this.state.cohorts} onBlur={this.handleCohortChange} />
              </div>
          }
          <div className="field">
            <label tabIndex="0" id="intakeDateRangeLabel">Last Updated Date Range</label>
            <DateRange numberOfMonths={2} startDate={this.state.startUpdateDate} endDate={this.state.endUpdateDate}
              onDatesChange={this.handleDatesChange}
              screenReaderInputMessage="Last Updated Date Range" />
          </div>
        </div>
      </Form>
    );
  }
}

IntakeMainFilterPanel.propTypes = {
  cohortsEnabled: PropTypes.bool,

  notificationCenter: NotificationCenter.isRequired,
};
